/**
 * Studio Custom Filters
 * =====================
 * Client-side filtering for studio/recording collections.
 * Bypasses S&D 25-filter limit by filtering product cards directly in DOM.
 */
(function () {
  'use strict';

  var dataEl = document.getElementById('StudioFilterData');
  if (!dataEl) return;

  var studioData;
  try {
    studioData = JSON.parse(dataEl.textContent);
  } catch (e) {
    console.error('Studio filters: invalid JSON data');
    return;
  }

  var activeFilters = {};
  var productGrid = document.getElementById('ProductsList');
  var productCount = document.getElementById('ProductCount');
  var activeFiltersContainer = document.getElementById('StudioActiveFilters');
  var activeFilterTags = document.getElementById('StudioActiveFilterTags');
  var clearAllBtn = document.getElementById('StudioClearAllFilters');

  if (!productGrid) return;

  var productElements = {};
  var columns = productGrid.querySelectorAll('.f-column.product-column');
  columns.forEach(function (col) {
    var card = col.querySelector('.product-card');
    if (!card) return;
    var compareCheckbox = card.querySelector('[data-product-id]');
    if (compareCheckbox) {
      productElements[compareCheckbox.getAttribute('data-product-id')] = col;
    }
  });

  if (Object.keys(productElements).length === 0) {
    var productIds = Object.keys(studioData.products);
    var idx = 0;
    columns.forEach(function (col) {
      if (col.querySelector('.product-card') && idx < productIds.length) {
        productElements[productIds[idx]] = col;
        idx++;
      }
    });
  }

  function getActiveFilterCount() {
    var count = 0;
    Object.values(activeFilters).forEach(function (s) { count += s.size; });
    return count;
  }

  function applyFilters() {
    var hasActive = getActiveFilterCount() > 0;
    var visibleCount = 0;
    var imageColumns = productGrid.querySelectorAll('.f-column.image-column');

    Object.keys(productElements).forEach(function (pid) {
      var el = productElements[pid];
      var meta = studioData.products[pid];

      if (!hasActive) { el.style.display = ''; visibleCount++; return; }
      if (!meta) { el.style.display = 'none'; return; }

      var matches = true;
      Object.keys(activeFilters).forEach(function (fk) {
        var sel = activeFilters[fk];
        if (sel.size === 0) return;
        if (!sel.has(meta[fk] || '')) matches = false;
      });

      el.style.display = matches ? '' : 'none';
      if (matches) visibleCount++;
    });

    if (hasActive) {
      imageColumns.forEach(function (ic) { ic.style.display = 'none'; });
    } else {
      imageColumns.forEach(function (ic) { ic.style.display = ''; });
    }

    if (productCount) {
      var total = Object.keys(studioData.products).length;
      productCount.textContent = hasActive ? visibleCount + ' / ' + total + ' products' : total + ' products';
    }

    updateFilterCounts();
    updateActiveFiltersDisplay();
    updateURL();
  }

  function updateFilterCounts() {
    if (getActiveFilterCount() === 0) {
      document.querySelectorAll('.studio-filter-count').forEach(function (el) {
        el.textContent = el.getAttribute('data-original-count');
      });
      document.querySelectorAll('.studio-filter-checkbox').forEach(function (cb) {
        cb.disabled = false;
        cb.closest('li').classList.remove('opacity-50');
      });
      return;
    }

    studioData.fields.forEach(function (field) {
      field.values.forEach(function (valObj, idx) {
        var cb = document.getElementById('studio-filter-' + field.key + '-' + (idx + 1));
        if (!cb) return;
        var countEl = cb.closest('li').querySelector('.studio-filter-count');
        if (!countEl) return;

        var count = 0;
        Object.keys(studioData.products).forEach(function (pid) {
          var meta = studioData.products[pid];
          var matches = true;
          Object.keys(activeFilters).forEach(function (fk) {
            if (fk === field.key) return;
            var sel = activeFilters[fk];
            if (sel.size === 0) return;
            if (!sel.has(meta[fk] || '')) matches = false;
          });
          if (matches && meta[field.key] === valObj.value) count++;
        });

        countEl.textContent = count;
        if (count === 0 && !cb.checked) {
          cb.disabled = true;
          cb.closest('li').classList.add('opacity-50');
        } else {
          cb.disabled = false;
          cb.closest('li').classList.remove('opacity-50');
        }
      });
    });
  }

  function updateActiveFiltersDisplay() {
    if (!activeFiltersContainer || !activeFilterTags) return;
    if (getActiveFilterCount() === 0) { activeFiltersContainer.classList.add('hidden'); return; }

    activeFiltersContainer.classList.remove('hidden');
    var html = '';
    Object.keys(activeFilters).forEach(function (fk) {
      activeFilters[fk].forEach(function (val) {
        html += '<button type="button" class="studio-remove-filter btn btn--outline btn--small" '
          + 'data-field="' + fk + '" data-value="' + val.replace(/"/g, '&quot;') + '" '
          + 'style="font-size:0.75rem;padding:0.25rem 0.5rem;border-radius:2rem;display:inline-flex;align-items:center;gap:0.25rem;">'
          + '<span>' + val + '</span>'
          + '<svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M9 3L3 9M3 3l6 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>'
          + '</button> ';
      });
    });
    activeFilterTags.innerHTML = html;

    activeFilterTags.querySelectorAll('.studio-remove-filter').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var f = this.getAttribute('data-field'), v = this.getAttribute('data-value');
        if (activeFilters[f]) { activeFilters[f].delete(v); if (activeFilters[f].size === 0) delete activeFilters[f]; }
        document.querySelectorAll('.studio-filter-checkbox[data-studio-field="' + f + '"]').forEach(function (cb) {
          if (cb.getAttribute('data-studio-value') === v) cb.checked = false;
        });
        applyFilters();
      });
    });
  }

  function updateURL() {
    var url = new URL(window.location.href);
    Array.from(url.searchParams.keys()).forEach(function (k) { if (k.startsWith('sf_')) url.searchParams.delete(k); });
    Object.keys(activeFilters).forEach(function (fk) {
      activeFilters[fk].forEach(function (v) { url.searchParams.append('sf_' + fk, v); });
    });
    window.history.replaceState({}, '', url.toString());
  }

  function restoreFromURL() {
    var url = new URL(window.location.href);
    url.searchParams.forEach(function (val, key) {
      if (key.startsWith('sf_')) {
        var fk = key.substring(3);
        if (!activeFilters[fk]) activeFilters[fk] = new Set();
        activeFilters[fk].add(val);
        document.querySelectorAll('.studio-filter-checkbox[data-studio-field="' + fk + '"]').forEach(function (cb) {
          if (cb.getAttribute('data-studio-value') === val) cb.checked = true;
        });
      }
    });
    if (getActiveFilterCount() > 0) applyFilters();
  }

  document.querySelectorAll('.studio-filter-checkbox').forEach(function (cb) {
    cb.addEventListener('change', function () {
      var f = this.getAttribute('data-studio-field'), v = this.getAttribute('data-studio-value');
      if (!activeFilters[f]) activeFilters[f] = new Set();
      if (this.checked) { activeFilters[f].add(v); } else { activeFilters[f].delete(v); if (activeFilters[f].size === 0) delete activeFilters[f]; }
      applyFilters();
    });
  });

  if (clearAllBtn) {
    clearAllBtn.addEventListener('click', function () {
      Object.keys(activeFilters).forEach(function (k) { delete activeFilters[k]; });
      document.querySelectorAll('.studio-filter-checkbox').forEach(function (cb) { cb.checked = false; });
      applyFilters();
    });
  }

  restoreFromURL();
})();
